import { render } from "./OrdiniTable.vue?vue&type=template&id=126a9482&scoped=true"
import script from "./OrdiniTable.vue?vue&type=script&lang=js"
export * from "./OrdiniTable.vue?vue&type=script&lang=js"

import "./OrdiniTable.vue?vue&type=style&index=0&id=126a9482&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126a9482"]])

export default __exports__